<div id="modal-fail" class="modal-wrapper modal-open" role="dialog" aria-labelledby="modal-1-heading"
     aria-describedby="modal-1-description" tabindex="0" target="_blank">
  <div class="modal-body rounded-20 white text-center relative shadow">
    <div class="modal-content">
      <header>
        <div class="modal-title" id="modal-1-heading">
          <i class="fa-solid fa-circle-exclamation"></i> Contact Verification Failed
        </div>
      </header>
      <p class="font-18 bold font-gray-700" id="modal-1-description">
        <!--Please try again after some time cservice.contactVerificationFailedMsg -->
        Unfortunately, our system is experiencing technical issues. Please click on the “Skip Verification for Now” to access your application
      </p>
      <div class="modal-button-container button-adjust">
        <button title="Skip Verification" id="" class="rounded-full hover-blue-800 black mobile" (click)="cservice.continueBackToApplication()">
          <div class="btn-txt font-white">Skip Verification for Now</div>
        </button>
      </div>
    </div>    
  </div>  
</div>
